import React from 'react';
import { Row, Col } from 'antd';
import { Aside, Content } from './overview/style';

const AuthLayout = (WraperContent) => {
  return function () {
    return (
      <Row>
        <Col xxl={8} xl={9} lg={12} md={8} xs={24}>
          <Aside>
            <div className="auth-side-content">
              <img src={require('../../../static/img/auth/topShape.png')} alt="" className="topShape" />
              <img src={require('../../../static/img/auth/bottomShape.png')} alt="" className="bottomShape" />
              <Content>
                <img style={{ width: '250px' }} src={require('../../../static/img/auth/auth-page-illustration-logo.png')} alt="" />
                <img
                  className="auth-content-figure"
                  src={require('../../../static/img/auth/auth-page-illustration.png')}
                  alt=""
                  style={{marginTop: -75}}
                />
              </Content>
            </div>
          </Aside>
        </Col>

        <Col xxl={16} xl={15} lg={12} md={16} xs={24}>
          <WraperContent />
        </Col>
      </Row>
    );
  };
};

export default AuthLayout;
